import { render, staticRenderFns } from "./SubProfile.vue?vue&type=template&id=a132a592&scoped=true"
import script from "./SubProfile.vue?vue&type=script&lang=js"
export * from "./SubProfile.vue?vue&type=script&lang=js"
import style0 from "./SubProfile.vue?vue&type=style&index=0&id=a132a592&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a132a592",
  null
  
)

export default component.exports